import { PolicyItem } from 'app/store/types';

export type PolicyItemsType = (Omit<PolicyItem, 'requirement' | 'remediation'> & { parentKey?: PolicyItem['key'] })[];
// Password Rules Key
export const adminpwrKey = 'adminpwr';
export const passwordModeKey = `${adminpwrKey}/PasswordMode`;
export const passwordLengthKey = `${adminpwrKey}/MinPasswordLength`;
export const prohibitedWordkey = `${adminpwrKey}/ProhibitedWordList`;
export const adminpwr = [
	adminpwrKey,
	passwordModeKey,
	passwordLengthKey,
	`${prohibitedWordkey}/0`,
	`${prohibitedWordkey}/1`,
	`${prohibitedWordkey}/2`,
	`${prohibitedWordkey}/3`,
	`${prohibitedWordkey}/4`,
	`${prohibitedWordkey}/5`,
	`${prohibitedWordkey}/6`,
	`${prohibitedWordkey}/7`,
	`${prohibitedWordkey}/8`,
	`${prohibitedWordkey}/9`
];
// PasswordMode option field
export const disablePasswordModeOption = 'Disable';
export const enablePasswordModeOption = 'Enable';
export const mode1PasswordModeOption = 'Mode1';
export const mode2PasswordModeOption = 'Mode2';
export const minPasswordLength = 8;
export const maxPasswordLength = 64;
export const messagePwrKey = 'it5PwrLimitations';
const allPolicyItems: PolicyItemsType = [
	{
		options: [{ val: true, tag: 'req' }],
		key: 'adminpw'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'adminpwr'
	},
	{
		options: [
			{
				val: disablePasswordModeOption,
				tag: 'req'
			},
			{
				val: mode1PasswordModeOption,
				tag: 'req'
			},
			{
				val: mode2PasswordModeOption,
				tag: 'req'
			}
		],
		key: adminpwr[1],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[2],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[3],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[4],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[5],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[6],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[7],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[8],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[9],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[10],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[11],
		parentKey: adminpwr[0]
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: adminpwr[12],
		parentKey: adminpwr[0]
	},
	{
		options: [
			{ val: 5, tag: 'timed' },
			{ val: 15, tag: 'timed' },
			{ val: 30, tag: 'timed' },
			{ val: 45, tag: 'timed' },
			{ val: 60, tag: 'timed' },
			{ val: 120, tag: 'timed' },
			{ val: 240, tag: 'timed' },
			{ val: 480, tag: 'timed' },
			{ val: 'Day1', tag: 'timed' },
			{ val: 'Day2', tag: 'timed' },
			{ val: 'Day3', tag: 'timed' },
			{ val: 'Day7', tag: 'timed' },
			{ val: 'Day30', tag: 'timed' }
		],
		key: 'autodoc'
	},
	// NOTE::figure out what this setting is doing...I don't know why we commented it out...
	// {
	// 	options: [{ val: true, tag: 'req' }],
	// 	key: 'backup'
	// },
	{
		options: [
			{ val: 5, tag: 'timed' },
			{ val: 15, tag: 'timed' },
			{ val: 30, tag: 'timed' },
			{ val: 45, tag: 'timed' },
			{ val: 60, tag: 'timed' },
			{ val: 120, tag: 'timed' },
			{ val: 240, tag: 'timed' },
			{ val: 480, tag: 'timed' },
			{ val: 'Day1', tag: 'timed' },
			{ val: 'Day2', tag: 'timed' },
			{ val: 'Day3', tag: 'timed' },
			{ val: 'Day7', tag: 'timed' },
			{ val: 'Day30', tag: 'timed' }
		],
		key: 'encryptpdf'
	},
	{
		options: [
			{ val: 5, tag: 'timed' },
			{ val: 15, tag: 'timed' },
			{ val: 30, tag: 'timed' },
			{ val: 45, tag: 'timed' },
			{ val: 60, tag: 'timed' },
			{ val: 120, tag: 'timed' },
			{ val: 240, tag: 'timed' },
			{ val: 480, tag: 'timed' },
			{ val: 'Day1', tag: 'timed' },
			{ val: 'Day2', tag: 'timed' },
			{ val: 'Day3', tag: 'timed' },
			{ val: 'Day7', tag: 'timed' },
			{ val: 'Day30', tag: 'timed' }
		],
		key: 'idandprint'
	},
	{
		options: [
			{ val: 5, tag: 'timed' },
			{ val: 15, tag: 'timed' },
			{ val: 30, tag: 'timed' },
			{ val: 45, tag: 'timed' },
			{ val: 60, tag: 'timed' },
			{ val: 120, tag: 'timed' },
			{ val: 240, tag: 'timed' },
			{ val: 480, tag: 'timed' },
			{ val: 'Day1', tag: 'timed' },
			{ val: 'Day2', tag: 'timed' },
			{ val: 'Day3', tag: 'timed' },
			{ val: 'Day7', tag: 'timed' },
			{ val: 'Day30', tag: 'timed' }
		],
		key: 'securebox'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'tempdata'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'hddencrypt'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'hddpass'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'userauth'
	},
	{
		options: [
			{ val: 1, tag: 'off' },
			{ val: 2, tag: 'onwi' },
			{ val: 3, tag: 'onwo' }
		],
		key: 'publicauth'
	},
	{
		options: [
			{ val: 'Admin', tag: 'crtenab-admin-mode' },
			{ val: 'UserAdmin', tag: 'crtenab-admin-mode-and-user-mode' }
		],
		key: 'crtenab'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'ssl'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'tls10'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'tls11'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'tls12'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'tls13'
	},
	{
		options: [
			{ val: 1, tag: 'timed' },
			{ val: 2, tag: 'timed' },
			{ val: 3, tag: 'timed' },
			{ val: 4, tag: 'timed' },
			{ val: 5, tag: 'timed' },
			{ val: 6, tag: 'timed' },
			{ val: 7, tag: 'timed' },
			{ val: 8, tag: 'timed' },
			{ val: 9, tag: 'timed' },
			{ val: 10, tag: 'timed' },
			{ val: 20, tag: 'timed' },
			{ val: 30, tag: 'timed' },
			{ val: 40, tag: 'timed' },
			{ val: 50, tag: 'timed' },
			{ val: 60, tag: 'timed' }
		],
		key: 'admtmout'
	},
	{
		options: [
			{ val: 1, tag: 'timed' },
			{ val: 2, tag: 'timed' },
			{ val: 3, tag: 'timed' },
			{ val: 4, tag: 'timed' },
			{ val: 5, tag: 'timed' },
			{ val: 6, tag: 'timed' },
			{ val: 7, tag: 'timed' },
			{ val: 8, tag: 'timed' },
			{ val: 9, tag: 'timed' },
			{ val: 10, tag: 'timed' },
			{ val: 20, tag: 'timed' },
			{ val: 30, tag: 'timed' },
			{ val: 40, tag: 'timed' },
			{ val: 50, tag: 'timed' },
			{ val: 60, tag: 'timed' }
		],
		key: 'usrtmout'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'ftsvenab'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'fttxenab'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'jblgenab'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'jblg/InspectLog'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'jblg/CollectionLog',
		parentKey: 'jblg/InspectLog'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'jblg/AddupLog',
		parentKey: 'jblg/InspectLog'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'jblg/JobLogInspectLog',
		parentKey: 'jblg/InspectLog'
	},
	{
		options: [
			{ val: 'manual_xml', tag: 'jblgtxmethod' },
			{ val: 'auto_xml', tag: 'jblgtxmethod' },
			{ val: 'auto_syslog', tag: 'jblgtxmethod' }
		],
		key: 'jblg/TxMethod',
		parentKey: 'jblg/InspectLog'
	},
	{
		options: [
			// @ts-ignore
			{ val: true, tag: 'jblgoverwrite' },
			{ val: false, tag: 'jblgoverwrite' }
		],
		key: 'jblg/OverWrite',
		parentKey: 'jblg/InspectLog'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'slp'
	},
	{
		options: [
			{ val: 'Day1', tag: 'timed' },
			{ val: 'Day2', tag: 'timed' },
			{ val: 'Day3', tag: 'timed' },
			{ val: 'Day7', tag: 'timed' },
			{ val: 'Day30', tag: 'timed' }
		],
		key: 'mfpsharedfolder'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'snmpv1v2'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'snmpv3'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'snmpv3/EnableSnmpV3',
		parentKey: 'snmpv3'
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: 'snmpv3/UdpPortNo',
		parentKey: 'snmpv3'
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: 'snmpv3/ContextName',
		parentKey: 'snmpv3'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'snmpv3/EnableDiscoveryUser',
		parentKey: 'snmpv3'
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: 'snmpv3/DiscoveryUserName',
		parentKey: 'snmpv3'
	},
	{
		options: [
			{ val: 'Des', tag: 'algo' },
			{ val: 'Aes128', tag: 'algo' }
		],
		key: 'snmpv3/Snmpv3Encryption',
		parentKey: 'snmpv3'
	},
	{
		options: [
			{ val: 'Md5', tag: 'auth' },
			{ val: 'Sha_1', tag: 'auth' }
		],
		key: 'snmpv3/Snmpv3AuthType',
		parentKey: 'snmpv3'
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: 'snmpv3/ReadUserName',
		parentKey: 'snmpv3'
	},
	{
		options: [
			{ val: 'None', tag: 'secLvl' },
			{ val: 'auth-password', tag: 'secLvl' },
			{ val: 'auth-password/priv-password', tag: 'secLvl' }
		],
		key: 'snmpv3/ReadUserSecurityLevel',
		parentKey: 'snmpv3'
	},
	{
		options: [{ val: '%USER_DEFINED%', tag: '%USER_DEFINED%' }],
		key: 'snmpv3/WriteUserName',
		parentKey: 'snmpv3'
	},
	{
		options: [
			{ val: 'None', tag: 'secLvl' },
			{ val: 'auth-password', tag: 'secLvl' },
			{ val: 'auth-password/priv-password', tag: 'secLvl' }
		],
		key: 'snmpv3/WriteUserSecurityLevel',
		parentKey: 'snmpv3'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'ultilicensed'
	},
	{
		options: [{ val: true, tag: 'req' }],
		key: 'patternfileversion',
		parentKey: 'ultilicensed'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'patternfilewarning',
		parentKey: 'ultilicensed'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'rtscan',
		parentKey: 'ultilicensed'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'rtscn/RealTimeScan',
		parentKey: 'ultilicensed'
	},
	{
		options: [
			{ val: 'Level1', tag: 'rtscn/VirusDetectedJob' },
			{ val: 'Level2', tag: 'rtscn/VirusDetectedJob' },
			{ val: 'Level3', tag: 'rtscn/VirusDetectedJob' }
		],
		key: 'rtscn/VirusDetectedJob',
		parentKey: 'ultilicensed'
	},
	{
		options: [
			{ val: true, tag: 'req' },
			{ val: false, tag: 'noreq' }
		],
		key: 'regscan',
		parentKey: 'ultilicensed'
	}
];

export default allPolicyItems;

export const remediatablePolicyItems: PolicyItem['key'][] = [
	...adminpwr,
	'crtenab',
	'ssl',
	'tls10',
	'tls11',
	'tls12',
	'tls13',
	'admtmout',
	'usrtmout',
	'ftsvenab',
	'fttxenab',
	'jblg/InspectLog',
	'jblg/CollectionLog',
	'jblg/AddupLog',
	'jblg/JobLogInspectLog',
	'jblg/TxMethod',
	'jblg/OverWrite',
	'mfpsharedfolder',
	'autodoc',
	'encryptpdf',
	'idandprint',
	'securebox',
	'snmpv1v2',
	'snmpv3/EnableSnmpV3',
	'snmpv3/UdpPortNo',
	'snmpv3/ContextName',
	'snmpv3/EnableDiscoveryUser',
	'snmpv3/DiscoveryUserName',
	'snmpv3/Snmpv3Encryption',
	'snmpv3/Snmpv3AuthType',
	'snmpv3/ReadUserName',
	'snmpv3/ReadUserSecurityLevel',
	'snmpv3/WriteUserName',
	'snmpv3/WriteUserSecurityLevel',
	'slp',
	'patternfilewarning',
	'rtscn/RealTimeScan',
	'rtscn/VirusDetectedJob',
	'regscan'
];
